import { Field } from '../Field/Field';
import { SliderInput } from './SliderInput';
import { SliderProps } from './types';

export const Slider = ({
  label,
  isDisabled,
  hintMessage,
  errorMessage,
  warningMessage,
  popoverHelpContent,
  i18nLocale,
  ...sliderInputProps
}: SliderProps) => {
  const hasError = sliderInputProps.hasError || Boolean(errorMessage);
  return (
    <Field
      label={label}
      isDisabled={isDisabled}
      hintMessage={hintMessage}
      errorMessage={errorMessage}
      warningMessage={warningMessage}
      popoverHelpContent={popoverHelpContent}
      i18nLocale={i18nLocale}
    >
      <SliderInput
        {...sliderInputProps}
        label={label}
        hasError={hasError}
        isDisabled={isDisabled}
        i18nLocale={i18nLocale}
      />
    </Field>
  );
};
